// The server refuses a number beyond this (`InventoryWrites::LIMIT`, which `SheetWrites` uses).
const LIMIT = 1_000_000_000;

export type Relative = { delta: number } | { set: number };

// What a PV field's typed text means: "-7" and "+3" are changes, a plain number is the value, anything else (a lone
// sign, a zero change, text) is nothing and the field goes back to its value.
export function parseRelative(text: string): Relative | null {
	const typed = text.trim();
	const number = Math.trunc(Number(typed));
	if (typed === "" || !Number.isFinite(number) || Math.abs(number) > LIMIT) return null;
	if (typed.startsWith("+") || typed.startsWith("-")) return number === 0 ? null : { delta: number };
	return { set: number };
}

// ArrowUp/ArrowDown on typed text: moves the number and keeps its meaning, so "4" stays a value and "-3" a change. A
// change that reaches zero keeps its sign ("-0"), which commits nothing. Text that is not a number answers null.
export function stepRelative(text: string, direction: 1 | -1): string | null {
	const typed = text.trim();
	const number = Math.trunc(Number(typed));
	if (typed === "" || !Number.isFinite(number)) return null;
	const next = number + direction;
	if (Math.abs(next) > LIMIT) return null;
	if (!typed.startsWith("+") && !typed.startsWith("-")) return String(next);
	if (next === 0) return typed.startsWith("-") ? "-0" : "+0";
	return next > 0 ? `+${next}` : String(next);
}
